import { History } from 'history';
import { HISTORY_ACTIONS } from '../constants/historyActions';

export const delayedScrollToTopOnBack = (history: History) => {
  return setTimeout(() => {
    if (history.action === HISTORY_ACTIONS.pop || history.action === HISTORY_ACTIONS.replace) {
      window.scrollTo(0, 0);
    }
  }, 100);
};
